import axios from 'axios';
import { getCookies } from './Utility';

const API_URL = process.env.REACT_APP_BASE_URL

const Api = {
  getDropdowns: async function (project_id) {
    try {
      const response = await axios.get(`${API_URL}/public/dropdowns`, {
        params: {
          project_id
        }
      });
      return response.data.data;
    } catch (e) {
      console.log('ERROR', e)
    }
  },
  getClientProject: async function (client_dp_handle, project_dp_handle) {
    const response = await axios.get(`${API_URL}/public/project`, {
      params: { client_dp_handle, project_dp_handle }
    });
    return response;
  },
  sendR2Email: async function (data) {
    const { name, email, subject, message, reason, token } = data;
    const response = await axios.post(
      'https://api.r2c.io/sendmail',
      {
        reason, name, email, subject, message, token
      });
    return response;
  },
  submitRequest: async function (data) {
    const response = await axios.post(`${API_URL}/privacy-requests`, { ...data },);
    return response;
  },

  getTableData: async function (classes, project_id) {
    const id_token = getCookies("auth-token");
    const id_tenant = getCookies("tenant-id");
    const response = await axios.get((classes == "tenants" || classes == "users") ? `${API_URL}/${classes}` : `${API_URL}/tenants/${id_tenant}/${classes}`, { headers: { "Authorization": `JWT ${id_token}` }, params: { project_id } }).catch(function (error) {
      if (error.response) {

        return error.response;

      }
    });
    if (response)
      return response;
  },

  generateOtp: async function (data) {
    const response = await axios.post(`${API_URL}/auth/otp`, { ...data }).catch(function (error) {
      if (error.response) {

        return error.response.data

      }
    });
    // console.log(response)
    return response;
  },
  verifyOtp: async function (data) {
    const response = await axios.post(`${API_URL}/auth/otp/verify`, { ...data });
    return response;
  },

  uploadFile: async function (payload) {
    const id_token = getCookies("auth-token");
    const id_tenant = getCookies("tenant-id");
    const formData = new FormData();

    formData.append("file", payload);
    formData.append("tenant_id", id_tenant);


    return axios({
      url: `${API_URL}/uploads`,
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `JWT ${id_token}`
      },
    })
      .then((response) => {
        return response?.data?.data
      });

  },

  createFile: async function (payload, name) {
    const id_token = getCookies("auth-token");
    const id_tenant = getCookies("tenant-id");


    const project_id = localStorage.getItem('DP_PROJECT_ID');
    return axios({
      url: (name == "tenants" || name == "users") ? `${API_URL}/${name}` : `${API_URL}/tenants/${id_tenant}/${name}${project_id ? '?project_id=' + project_id : ''}`,
      method: "POST",
      data: payload,
      headers: {

        "Authorization": `JWT ${id_token}`
      },
    })
      .then((response) => {
        return response?.data
      }).catch((error) => {
        if (error.response) {

          return error.response.data

        }
      });

  },

  updateFile: async function (payload, name, id) {
    const id_token = getCookies("auth-token");
    const id_tenant = getCookies("tenant-id");



    return axios({
      url: name == "tenants" ? `${API_URL}/tenants/${id}` :
        name == "users" ? `${API_URL}/${name}/${id}` :
          `${API_URL}/tenants/${id_tenant}/${name}/${id}?project_id=${localStorage.getItem('DP_PROJECT_ID')}`,
      method: "PUT",
      data: payload,
      headers: {

        "Authorization": `JWT ${id_token}`
      },
    })
      .then((response) => {
        return response?.data
      });

  },

  getSingleFile: async function (id, name, project_id) {
    const id_token = getCookies("auth-token");
    const id_tenant = getCookies("tenant-id");
    return axios({
      url: (name == "tenants" || name == "users") ? `${API_URL}/${name}/${id}` : `${API_URL}/tenants/${id_tenant}/${name}/${id}${project_id ? "?project_id=" + localStorage.getItem('DP_PROJECT_ID') : ""}`,
      method: "GET",

      headers: {

        "Authorization": `JWT ${id_token}`
      },
    })
      .then((response) => {
        return response?.data
      });

  }

};

export default Api;